import request from "@/utils/httpRequest.js"

/**
 * @param {} data
 */
 export function fetchBanner(params) {
  return request({
    url: 'banner',
    method: 'get',
    params
  })
}